import { render } from "./BooKmark.vue?vue&type=template&id=6bc0f44d"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BooKmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bc0f44d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bc0f44d', __exports__)) {
    api.reload('6bc0f44d', __exports__)
  }
  
  module.hot.accept("./BooKmark.vue?vue&type=template&id=6bc0f44d", () => {
    api.rerender('6bc0f44d', render)
  })

}


export default __exports__